var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[(_vm.isMask === true)?[_c('MaskComponent')]:[_c('HeaderComponent'),_c('router-view'),_c('FooterComponent')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }